<!-- possible to refactor to shadcn's popover (https://www.shadcn-vue.com/docs/components/popover.html) -- one day -->
<template>
  <div
    v-click-outside="() => isShown = false"
    class="inline-flex flex-col "
  >
    <button
      :id="placeholder"
      class="font-bold hover:opacity-75 focus:outline-none nav-first-level"
      :class="{ 'border-b-2 border-primary-140': isShown }"
      aria-label="User menu"
      aria-haspopup="true"
      @click="isShown = !isShown; $emit('sendEventGtm');"
    >
      {{ placeholder }}
      <t-icon
        name="fa-solid fa-chevron-down"
        :class="{ 'transform rotate-180': isShown }"
        class="text-text-primary hover:text-primary-120 text-sm"
        style="cursor: pointer;"
      />
    </button>
    <div
      tabindex="-1"
      class="relative z-20"
    >
      <transition>
        <div
          v-show="isShown"
          :class="dropdownPositionClass"
          class="w-50 rounded shadow mt-1 text-sm bg-primary-140 text-white w-max absolute transition duration-150 ease-in-out"
          @click="isShown = !isShown"
        >
          <slot name="dropdown-content" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { clickOutside,} from '/directives/clickOutside';

export default {
  name: 'DropdownCustom',
  directives: {
    clickOutside,
  },
  props: {
    variant: {
      type: String,
      default: '',
    },
    elementId: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    textAttribute: {
      type: String,
      default: '',
    },
    valueAttribute: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:modelValue', 'sendEventGtm'],
  data() {
    return {
      isShown: false,
      // setting v-models: https://vuejs.org/guide/components/v-model.html#basic-usage
      value: '',
      variantMap: {
        default: 'block appearance-none w-full px-4 pr-8 rounded focus:outline-none focus:bg-white focus:border-gray-500',
        clientForm: 'block pl-3 pr-8 py-2 text-gray-400 border text-sm rounded border-gray-200 bg-white focus:border-primary-140',
        signup: 'block w-full pl-3 pr-8 py-4 text-black border rounded border-gray-200 font-bold h4 bg-white focus:border-primary-140',
        checkout: 'border rounded shadow-sm border-gray-300 block pl-3 pr-8 py-2 text-sm text-black bg-white focus:border-primary-140',
        courseEnrollment: 'border rounded shadow-sm border-gray-300 block pl-2 pr-8 py-1 text-sm font-bold text-black bg-white focus:border-primary-140',
        home: 'block pl-3 pr-8 py-4 text-text-secondary border-none font-bold h4 bg-white focus:border-primary-140 ',
        course: 'block pl-3 pr-8 py-3 text-text-secondary border-2 border-matte-gray font-bold h4 bg-white focus:border-primary-140 ',
        courseMobile: 'block pl-3 pr-8 py-2 text-text-secondary border-2 border-matte-gray font-bold text-sm font-bold bg-white focus:border-primary-140 ',
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success: 'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
        nav: 'p-0 text-black',
        core100: 'text-pink border rounded border-pink py-2 font-bold text-sm',
        ceTracker: 'block pl-3 pr-8 h-12 text-black border rounded border-gray-200 font-bold h4 bg-white focus:border-primary-140',
      },
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    dropdownPositionClass() {
      if (this.placeholder === 'Group Sales') {
        return 'origin-top-right right-0';
      } else if (this.placeholder === 'Courses' && this.windowWidth < 1162) {
        return 'origin-top-left left-[-150px]';
      }
      else {
        return 'origin-top-left left-0';
      }
    },
    selectedVariant() {
      if (this.variant.length > 0 && this.variant in this.variantMap) {
        return this.variantMap[this.variant];
      }
      else {
        return this.variantMap.default;
      }
    },
  },
  mounted() {
    // Add event listener when component is mounted
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    // Clean up event listener when component is unmounted
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    setFirstOptionDisabled() {
      const selectElement = document.getElementById(this.elementId);
      console.log('select element', selectElement);
      const optionElement = selectElement.options[0];
      optionElement.setAttribute('disabled', 'disabled');
    },
    customEmit(value) {
      this.$emit('update:modelValue', value);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },

  },
};
</script>

<style>
.v-enter-from { opacity: 0 }
.v-enter-to   { opacity: 2 }

.v-enter-active,
.v-leave-active {
  transition: opacity .15s ease-in-out;
}
.v-leave-from { opacity: 2 }
.v-leave-to   { opacity: 0 }
</style>
